module.exports = __webpack_public_path__ + "assets/img/28.6adbf9ea.png";